import React from 'react';
import { withTranslation } from 'react-i18next';
import ListGroup from "../../../common/ListGroup";
import Loader from '../../../shared/components/Loader/Loader';
import axios from '../../../utils/axiosConfig';
import userSession from '../../../utils/userSession';

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeUserOffers: [],
      loading: true,
      error: false,
      isMounted: true
    };
  }

  componentDidMount() {
    this.fetchActiveOffers();
  }

  componentWillUnmount() {
    this.setState({
      isMounted: false
    });
  }

  componentDidUpdate(prevProps) {
    if(this.props.simulatedUserId != prevProps.simulatedUserId) {
      this.setState({ loading: true });
      this.fetchActiveOffers();
    }
  }

  fetchActiveOffers() {
    const userId = userSession('id');

    userId && axios.get(`/api/v1/influencers/influencers/${userId}/active_offers.json`)
      .then((response) => {
        if (this.state.isMounted) {
          this.setState({ activeUserOffers: response.data, loading: false, error: false });
        }
      })
      .catch(error => {
        if (this.state.isMounted) {
          this.setState({ loading: false, error: true });
        }
      });
  }

  render() {
    let { activeUserOffers, error, loading } = this.state;
    const userId = userSession('id');
    const { t } = this.props;

    if (loading || error) {
      return <Loader loading={loading} error={error} />
    }

    if (activeUserOffers.length > 0) {
      return (
        <div className="info-section active-offers mb-6">
          {userId &&
            <ListGroup
              title={t('influencers.pages.home.active_offers')}
              objects={activeUserOffers}
              objectType='userOffer'
              listGroupKey='active-offers'
              loading={loading}
              error={error}
            />
          }
        </div>
      );
    }

    return "";

  }
}

export default withTranslation()(Home);
